import { render, staticRenderFns } from "./UcInvoiceGroup.yaml?vue&type=template&id=4d93a237&component"
import script from "./UcInvoiceGroup.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceGroup.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports